// extracted by mini-css-extract-plugin
export default {"title_wrap":"style_title_wrap__9zPGO","title_content":"style_title_content__squW4","title":"style_title__XMWkM"};